// @flow

import styled from 'styled-components';

export const Description = styled.p`
  color: rgba(51, 51, 51, 0.8);
  line-height: 1.5em;
`;

export const DescriptionTextHighlight = styled.span`
  font-weight: bold;
`;
